import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormGroup from "@mui/material/FormGroup";
import FormLabel from "@mui/material/FormLabel";
import Switch from "@mui/material/Switch";
import _ from "lodash";
import React, { useEffect, useState } from "react";

import TaskToolTip from "./taskToolTip";
import { getUnitPropertie } from "../../functions";

function TaskFieldCheckList(props) {
  const checkArray = props.value
    ? props.value.length > 0 && JSON.parse(props.value)
    : [];

  const state = {
    checkedOptions:
      checkArray && checkArray.values && checkArray.values.length > 0
        ? checkArray.values
        : [],
  };

  const [urloptions, setUrlOptions] = useState([]);

  const getOptions = (_options) => {
    const { color, readOnly, size, style, fieldProperties, form } = props;
    const { checkedOptions } = state;

    const isApiOrVariableType =
      _options && (_options.type === "variable" || _options.type === "api");

    const variableName =
      isApiOrVariableType && getUnitPropertie(fieldProperties, "variableName");
    const jsonFieldValue =
      isApiOrVariableType &&
      getUnitPropertie(fieldProperties, "jsonFieldValue");
    const jsonFieldText =
      isApiOrVariableType && getUnitPropertie(fieldProperties, "jsonFieldText");
    let jsonProcessVariableList = [];

    // converte a variavel do processo para json
    if (isApiOrVariableType) {
      const processVariableList =
        (isApiOrVariableType &&
          form &&
          form.values &&
          form.values[variableName]) ||
        "[]";
      try {
        jsonProcessVariableList = JSON.parse(processVariableList);
      } catch (err) {
        console.error(err);
      }
    }

    const switchSize = size ? "small" : "medium";
    const options = [];

    _options &&
      _options.type === "api" &&
      urloptions &&
      urloptions.length &&
      urloptions.map &&
      urloptions.map((option) => {
        const valueField = jsonFieldValue
          ? option[jsonFieldValue]
          : option.value;
        const textField = jsonFieldText ? option[jsonFieldText] : option.text;

        return options.push(
          <FormControlLabel
            style={style}
            control={
              <Switch
                // disabled={readOnly}
                size={switchSize}
                color={color}
                value={valueField}
                onChange={
                  !readOnly ? () => handleOnChange(valueField) : undefined
                }
                checked={
                  checkedOptions && checkedOptions.indexOf(valueField) !== -1
                }
              />
            }
            label={textField}
          />,
        );
      });

    _options &&
      _options.type === "options" &&
      _options.value.map((option) => {
        return (
          option &&
          options.push(
            <FormControlLabel
              style={style}
              control={
                <Switch
                  // disabled={readOnly}
                  color={color}
                  size={switchSize}
                  value={option.value}
                  onChange={
                    !readOnly ? () => handleOnChange(option.value) : undefined
                  }
                  checked={
                    checkedOptions &&
                    checkedOptions.indexOf(option.value) !== -1
                  }
                />
              }
              label={option.text}
            />,
          )
        );
      });

    _options &&
      _options.type === "variable" &&
      Array.isArray(jsonProcessVariableList) &&
      jsonProcessVariableList.map((option) => {
        const valueField = jsonFieldValue
          ? option[jsonFieldValue]
          : option.value;
        const textField = jsonFieldText ? option[jsonFieldText] : option.text;
        return options.push(
          <FormControlLabel
            style={style}
            control={
              <Switch
                // disabled={readOnly}
                size={switchSize}
                color={color}
                value={valueField}
                onChange={
                  !readOnly ? () => handleOnChange(valueField) : undefined
                }
                checked={
                  checkedOptions && checkedOptions.indexOf(valueField) !== -1
                }
              />
            }
            label={textField}
          />,
        );
      });

    return options;
  };

  const handleOnChange = (value) => {
    const { attributes, onChange } = props;
    const { checkedOptions } = state;
    const result = checkedOptions;

    const currentIndex = checkedOptions.indexOf(value);

    if (currentIndex === -1) {
      result.push(value);
    } else {
      result.splice(currentIndex, 1);
    }

    const checkboxListObject = { type: "checkboxList", values: result };

    const camundaValue = {
      type: "Json",
      value: JSON.stringify(checkboxListObject),
      valueInfo: {},
    };
    onChange &&
      onChange(attributes.id, JSON.stringify(checkboxListObject), camundaValue);
  };

  useEffect(() => {
    try {
      const fieldppties = props.fieldProperties.properties;
      const urlEnumOptions = getObjectPropertie(fieldppties, "options");

      urlEnumOptions &&
        urlEnumOptions.type === "api" &&
        urlEnumOptions.value.length > 1 &&
        loadUrlOptions(urlEnumOptions);
    } catch (error) {}
  }, [props.fieldProperties]);

  const loadUrlOptions = async (urlEnumOptions) => {
    try {
      const json = await fetch(urlEnumOptions.value, {
        method: "GET",
        mode: "cors",
      }).then((response) => response.json());

      setUrlOptions(json);
    } catch (error) {
      console.log(error);
    }
  };

  const getObjectPropertie = (fieldProperties, id) => {
    const model =
      fieldProperties &&
      _.find(fieldProperties, function (a) {
        return a.id === id;
      });
    //model = model;
    return model;
  };
  const { error, fieldProperties, toolTip } = props;

  // let label = attributes && attributes.label;
  const isRequired = getUnitPropertie(fieldProperties, "isRequired");
  const label = getUnitPropertie(fieldProperties, "label");
  const objeto = getObjectPropertie(
    props.fieldProperties.properties,
    "options",
  );
  const _options = getOptions(objeto);

  return (
    <TaskToolTip title={toolTip}>
      <FormControl error={error} component="fieldset">
        <FormLabel component="legend" required={isRequired}>
          {label}
        </FormLabel>
        <FormGroup>{_options}</FormGroup>
      </FormControl>
    </TaskToolTip>
  );
}

// const mapStateToProps = createStructuredSelector({
//   urloptions: selectEnumOption,
//   value: (state, props) => selectFilterFormValuesSelector(state, props.id),
// });
//
// const mapDispatchToProps = {
//   fetchEnumOptions,
// };

export default TaskFieldCheckList;
